import { render, staticRenderFns } from "./IdeasVotingContent.vue?vue&type=template&id=17d9109a&scoped=true&"
import script from "./IdeasVotingContent.vue?vue&type=script&lang=js&"
export * from "./IdeasVotingContent.vue?vue&type=script&lang=js&"
import style0 from "./IdeasVotingContent.vue?vue&type=style&index=0&id=17d9109a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d9109a",
  null
  
)

export default component.exports